// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__ZODbl","header":"layout_header__FEu8b","aside":"layout_aside__2Kwxd","main":"layout_main__xdkqO"};